'use client'

import { useEffect, useState } from 'react'

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(false)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Initialise from current state
    setIsOffline(!navigator.onLine)

    const goOffline = () => setIsOffline(true)
    const goOnline = () => setIsOffline(false)

    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)
    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  // Slide in when going offline, slide out when back online
  useEffect(() => {
    if (isOffline) {
      setVisible(true)
    } else {
      // Keep mounted during fade-out so the animation plays
      const t = setTimeout(() => setVisible(false), 400)
      return () => clearTimeout(t)
    }
  }, [isOffline])

  if (!visible) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: '0.75rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: '0.45rem',
        padding: '0.45rem 1rem',
        borderRadius: '99px',
        background: '#1a1a1a',
        color: '#fff',
        fontSize: '0.78rem',
        fontWeight: 500,
        letterSpacing: '0.01em',
        boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
        whiteSpace: 'nowrap',
        opacity: isOffline ? 1 : 0,
        transition: 'opacity 0.35s ease',
        pointerEvents: 'none',
      }}
    >
      {/* Pulsing dot */}
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: '#f87171',
          display: 'inline-block',
          animation: isOffline ? 'gallium-pulse 1.6s ease-in-out infinite' : 'none',
          flexShrink: 0,
        }}
      />
      You&rsquo;re offline — showing cached content
      <style>{`
        @keyframes gallium-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.4; transform: scale(0.75); }
        }
      `}</style>
    </div>
  )
}
